import React from "react";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import DoneIcon from "@mui/icons-material/Done";

const API_BASE = process.env.REACT_APP_API_URL || "https://capizflow.duckdns.org";

function formatTime(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr + "Z");
  if (isNaN(d.getTime())) return "";
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

function MessageStatus({ status }) {
  // status: "sent" (single), "delivered" (double gray), "read" (double blue)
  if (status === "read") {
    return (
      <span className="message-tick read" title="Read">
        <DoneAllIcon sx={{ fontSize: 16 }} />
      </span>
    );
  }
  if (status === "delivered") {
    return (
      <span className="message-tick sent" title="Delivered">
        <DoneAllIcon sx={{ fontSize: 16 }} />
      </span>
    );
  }
  return (
    <span className="message-tick sent" title="Sent">
      <DoneIcon sx={{ fontSize: 16 }} />
    </span>
  );
}

function Message({ msg }) {
  const isIncoming = msg.direction === "incoming";
  const body = msg.body || "";

  const tickStatus = (() => {
    if (isIncoming) return null;
    const s = (msg.status || msg.delivery_status || "").toLowerCase();
    if (s === "read") return "read";
    if (s === "delivered") return "delivered";
    if (s === "sent" || s === "" || s === "ok") return "delivered";
    return "sent";
  })();

  const renderContent = () => {
    if (body.startsWith("media:")) {
      const parts = body.substring(6).split("|");
      const filename = parts[0];
      const caption = parts[1] || "";
      const ext = filename.split(".").pop().toLowerCase();
      const mediaUrl = `${API_BASE}/media/${encodeURIComponent(filename)}`;

      return (
        <>
          {["jpg", "jpeg", "png", "webp", "gif"].includes(ext) && (
            <img
              src={mediaUrl}
              alt=""
              onClick={() => window.open(mediaUrl)}
              loading="lazy"
            />
          )}
          {["mp4", "3gp"].includes(ext) && <video src={mediaUrl} controls />}
          {["ogg", "mp3", "m4a", "aac", "amr"].includes(ext) && (
            <audio src={mediaUrl} controls />
          )}
          {!["jpg", "jpeg", "png", "webp", "gif", "mp4", "3gp", "ogg", "mp3", "m4a", "aac", "amr"].includes(ext) && (
            <a
              href={mediaUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#075e54", textDecoration: "underline" }}
            >
              📎 {filename}
            </a>
          )}
          {caption && <div>{caption}</div>}
        </>
      );
    }

    if (msg.message_type && !["text", "interactive", "template"].includes(msg.message_type) && isIncoming) {
      return (
        <>
          <div className="message-type-label">{msg.message_type}</div>
          {body}
        </>
      );
    }

    return body;
  };

  return (
    <div className={`message ${isIncoming ? "message-incoming" : "message-outgoing"}`}>
      <div className="message-body">{renderContent()}</div>
      <span className="message-meta">
        {formatTime(msg.created_at)}
        {tickStatus && <MessageStatus status={tickStatus} />}
      </span>
    </div>
  );
}

export default Message;
